import React, {useEffect} from "react";
import {Button, Form, Input} from "antd";
import {useModel} from "../../../models";

export default function () {
    const [form] = Form.useForm();
    const [{searchParam}, {setSearchParam, loadSupplierList}] = useModel("supplier");
    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [])

    const onFinish = () => {
        const params = form.getFieldsValue();
        // params.pageSize = 15
        // params.pageNum = 1
        setSearchParam(params)
        loadSupplierList({data:params});
    }
    const onReset = () => {
        form.resetFields();
        setSearchParam({})
        loadSupplierList({showMsg:false,data:{}});
    }
    return (
        <Form
            form={form}
            name="material_search"
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            <Form.Item
                name="supplierCode"
                label="供应商编码"
            >
                <Input placeholder="供应商编码"/>
            </Form.Item>
            <Form.Item
                name="supplierName"
                label="供应商名称"
            >
                <Input placeholder="供应商名称"/>
            </Form.Item>
            <Form.Item
                name="supplierPerson"
                label="联系人"
            >
                <Input placeholder="联系人"/>
            </Form.Item>
            <Form.Item
                name="supplierPhone"
                label="联系电话"
            >
                <Input placeholder="联系电话"/>
            </Form.Item>
            {/* <Form.Item
                name="supplierAddress"
                label="联系地址"
            >
                <Input placeholder="联系地址"/>
            </Form.Item> */}
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="submit"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}